export interface AppConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiUrl: string;
  appUrl: string;
  maxFileSizeBytes: number;
  allowedExpiryHours: number[];
}

let appConfig: AppConfig;

export async function loadConfig(): Promise<AppConfig> {
  if (import.meta.env.DEV) {
    appConfig = {
      region: import.meta.env.VITE_AWS_REGION ?? "ap-south-1",
      userPoolId: import.meta.env.VITE_USER_POOL_ID ?? "",
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? "",
      apiUrl: import.meta.env.VITE_API_URL ?? "",
      appUrl: window.location.origin,
      maxFileSizeBytes: Number(import.meta.env.VITE_MAX_FILE_SIZE_BYTES ?? 104857600),
      allowedExpiryHours: [1, 6, 12, 24, 72],
    };
  } else {
    const response = await fetch("/config.json", { cache: "no-store" });
    if (!response.ok) throw new Error("Could not load the DropJet runtime configuration");
    appConfig = (await response.json()) as AppConfig;
  }
  return appConfig;
}

export function config(): AppConfig {
  if (!appConfig) throw new Error("Application configuration has not been loaded");
  return appConfig;
}
